// Storage backend for admin auth ("data", "_TOKEN_") only — every other role
// (agency, agencyadmin, bd, coin panel) keeps using sessionStorage untouched.
//
// REACT_APP_ADMIN_STORAGE = "local" | "session" (default: "local" so an admin
// session survives a tab close/reopen instead of forcing re-login).
const backend =
  process.env.REACT_APP_ADMIN_STORAGE === "session" ? sessionStorage : localStorage;

const ADMIN_KEYS = ["data", "_TOKEN_"];

const adminStorage = {
  getItem: (key) => backend.getItem(key),
  setItem: (key, value) => backend.setItem(key, value),
  removeItem: (key) => backend.removeItem(key),
  // Only clears admin's own keys — never a blanket backend.clear(), since the
  // localStorage backend is shared with unrelated app data (e.g. _USER_TOKEN_).
  clear: () => ADMIN_KEYS.forEach((key) => backend.removeItem(key)),
};

export default adminStorage;
